import { post } from '@alltrails/core/utils/post';
import type ProResponse from '../types/ProResponse';
import type Subscription from '../types/Subscription';

// see app/controllers/api/alltrails/default/purchases/subscriptions_controller.rb
export default async function createSubscription(body: Subscription) {
  return post<ProResponse>('/api/alltrails/purchases/subscriptions', body);
}
